export default __webpack_public_path__ + "static/media/IconEdit.777037e6.svg";